import axios from "axios";
import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function ConfirmUpdateProfile({ profile, cancelModal ,goBack,refreshData}) {

  const [complete, setComplete] = useState(false);
  const navi = useNavigate()
  const {user} = useAuthContext()
  const [isLoading, setIsLoading] = useState(false);
//styled
const handleUpdate = async () => {
  setIsLoading(true);
  try {
    const update = {
      id: profile.id,
      firstName: profile.firstName,
      lastName: profile.lastName,
    };

    const updateResponse = await axios.put(
      `${ApiConnectionString}/api/bookingProfile`,
      update,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (updateResponse.status === 200) {
      setComplete(true); // Indicate successful update
    }
  } catch (error) {
    console.error("Error updating booking profile:", error);
    // Optionally, handle the error (e.g., display an error message to the user)
  } finally {
    setIsLoading(false); // Reset the loading state
  }
};


  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  }else{

  

  if (complete) {
    return (
        <div className="send-modal-overlay">
      
        <div className="send-modal">
      
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Profile Updated</p></div> 
        <p>The profile was successfully updated.</p>

            <div className="send-modal-footer">
              <button  className="pointer cancelButton fw-bold mx-2 px-3" onClick={() => {goBack();cancelModal()}}>Okay</button>
            </div>
        
        </div>
      </div>
      )
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
       
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Confirm Update Profile</p></div> 

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>
       
           <table>
  <tbody>
    <tr>
      <td className="red-text"><strong>First Name:</strong></td>
      <td>{profile.firstName}</td>
    </tr>
    <tr>
      <td className="red-text"><strong>Last Name:</strong></td>
      <td>{profile.lastName}</td>
    </tr>

 
  </tbody>
</table>
          <div className="send-modal-footer">
            <button
              className="saveChanges-button mx-3"
              onClick={() => {
                handleUpdate();
              }}
            >
              Confirm
            </button>
            <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
          </div>
        </div>
      </div>
    );
  }
}
}